"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-bitwise */
function generateUniqueId() {
    var first = (Math.random() * 46656) | 0;
    var second = (Math.random() * 46656) | 0;
    var strFirst = ("000" + first.toString(36)).slice(-3);
    var strSecond = ("000" + second.toString(36)).slice(-3);
    return strFirst + strSecond;
}
exports.generateUniqueId = generateUniqueId;
//# sourceMappingURL=uniqueId.js.map